module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG175e2912a82135ca8e01f72d07bd0461.175e2912.png";